import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import BackButton from '../ChildComponent/BackButton';
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';

const SETTINGS_SECTIONS = [
  {
    title: 'Session Settings',
    icon: 'fa-calendar-alt',
    color: '#84cc16',
    links: [
      { label: 'Session List', to: '/AdminMain/SessionSettings', icon: 'fa-list' },
      { label: 'Board', to: '/AdminMain/BoardMediumSettings', icon: 'fa-university' },
      { label: 'Medium', to: '/AdminMain/BoardMediumSettings', icon: 'fa-language' },
      { label: 'Department', to: '/AdminMain/DepartmentSettings', icon: 'fa-building' },
    ],
  },
  {
    title: 'Fee Settings',
    icon: 'fa-money-bill-wave',
    color: '#10b981',
    links: [
      { label: 'Fee Name', to: '/AdminMain/FeeNameList', icon: 'fa-list' },
      { label: 'Class Fee', to: '/AdminMain/ClassFee', icon: 'fa-graduation-cap' },
      { label: 'Siblings', to: '/AdminMain/Siblings', icon: 'fa-users' },
      { label: 'Special Case', to: '/AdminMain/SpecialCaseStudent', icon: 'fa-star' },
    ],
  },
  {
    title: 'Subject Settings',
    icon: 'fa-book',
    color: '#f59e0b',
    links: [
      { label: 'Subject Master List', to: '/AdminMain/SubjectList', icon: 'fa-list-alt' },
      { label: 'Class Subject', to: '/AdminMain/ClassSubject', icon: 'fa-graduation-cap' },
      { label: 'Student Subject', to: '/AdminMain/StudentSubject', icon: 'fa-user-graduate' },
      { label: 'Alternate Subject', to: '/AdminMain/AlternateSubject', icon: 'fa-exchange-alt' },
    ],
  },
  {
    title: 'Class Settings',
    icon: 'fa-graduation-cap',
    color: '#3b82f6',
    links: [
      { label: 'Class List', to: '/AdminMain/ClassSettings', icon: 'fa-list' },
    ],
  },
  {
    title: 'Fee Receipt Settings',
    icon: 'fa-receipt',
    color: '#8b5cf6',
    links: [
      { label: 'Option Settings', to: '/AdminMain/FeeReceiptSettings', icon: 'fa-cog' },
    ],
  },
  {
    title: 'Communication',
    icon: 'fa-broadcast-tower',
    color: '#0ea5e9',
    links: [
      { label: 'WhatsApp Account', to: '/AdminMain/WhatsAccountSettings', icon: 'fa-whatsapp' },
      { label: 'Communication Panel', to: '/AdminMain/CommunicationPanel', icon: 'fa-comments' },
    ],
  },
  {
    title: 'General Settings',
    icon: 'fa-cogs',
    color: '#f97316',
    links: [
      { label: 'Sign Settings', to: '/AdminMain/SignSettings', icon: 'fa-list' },
      { label: 'Font Settings', to: '/AdminMain/FontSettings', icon: 'fa-font' },
      { label: 'Certificate Settings', to: '/AdminMain/CertificateSettings', icon: 'fa-certificate' },
    ],
  },
  {
    title: 'Fine Settings',
    icon: 'fa-exclamation-triangle',
    color: '#dc2626',
    links: [
      { label: 'Fine Rule', to: '/AdminMain/FineRule', icon: 'fa-gavel' },
      { label: 'Fine Structure', to: '/AdminMain/FineSettings', icon: 'fa-sitemap' },
    ],
  },
];

const SettingsHome = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

            return (
              <div className="content">
                <div className="content-header d-flex justify-content-between align-items-center">
                  <div className="leftside-content-header d-flex align-items-center">
                    <i 
                      className="fa fa-home" 
                      aria-hidden="true" 
                      style={{ fontSize: '18px', color: COLORS.primary_color, cursor: 'pointer', marginRight: '10px' }}
            onClick={() => (window.location.href = '/AdminMain')}
                    />
                    <ul className="breadcrumbs mb-0">
                      <li>Settings</li>
                    </ul>
                  </div>
                  <div className="rightside-content-header">
                    <BackButton />
                  </div>
                </div>

      <div className="bg_page_white_rounded box_shadow st-page" style={{ '--mMargin': '50px' }}>
        <div className="st-grid">
          {SETTINGS_SECTIONS.map((section) => (
            <div
              className="st-card"
              key={section.title}
              style={{ '--st-color': section.color }}
            >
              <div className="st-card-head">
                <i className={`fa ${section.icon}`} aria-hidden="true" />
                {section.title}
                              </div>
              <div className="st-card-links">
                {section.links.map((link) => (
                  <Link
                    to={link.to}
                    key={`${section.title}-${link.label}`}
                    className="st-link"
                  >
                    <i className={`fa ${link.icon}`} aria-hidden="true" />
                    {link.label}
                            </Link>
                ))}
                        </div>
                        </div>
          ))}
                        </div>
                      </div>
                   
      <style>{`
        .st-page {
          padding: 16px;
        }
        .st-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px;
        }
        .st-card {
          border-radius: 14px;
          background: #ffffff;
          border: 1px solid color-mix(in srgb, var(--st-color) 28%, #e5e7eb);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }
        .st-card:hover {
          box-shadow: 0 6px 18px color-mix(in srgb, var(--st-color) 25%, transparent);
          transform: translateY(-2px);
        }
        .st-card-head {
          display: flex;
          align-items: center;
          gap: 9px;
          padding: 10px 14px;
          font-size: 15px;
          font-weight: 800;
          color: #ffffff;
          background: linear-gradient(135deg, var(--st-color) 0%, color-mix(in srgb, var(--st-color) 78%, #000000) 100%);
        }
        .st-card-head i {
          font-size: 14px;
        }
        .st-card-links {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          padding: 12px 14px 14px;
        }
        .st-link {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          padding: 5px 12px;
          border-radius: 999px;
          font-size: 12.5px;
          font-weight: 700;
          text-decoration: none !important;
          color: var(--st-color);
          background: color-mix(in srgb, var(--st-color) 7%, #ffffff);
          border: 1px solid color-mix(in srgb, var(--st-color) 30%, #e5e7eb);
          transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
        }
        .st-link i {
          font-size: 11px;
        }
        .st-link:hover {
          background: var(--st-color);
          color: #ffffff;
          transform: translateY(-1px);
        }
        @media (max-width: 992px) {
          .st-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (max-width: 640px) {
          .st-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

// Created By Cursor — settings home only; sub-pages use AdminMain routes (no nested Router)
const Settings = () => <SettingsHome />;

export default Settings
